export default __webpack_public_path__ + "static/media/bo.1fa4252f.svg";